import axios from "axios";
import { getAuthHeaders } from "./authHeaders";

// GET - lista todos os links de checkout do usuário
export async function getCheckoutLinks() {
  const res = await axios.get(
    "https://api.sobevenda.com.br/api-proxy/affiliate/checkout-links",
    { headers: getAuthHeaders() }
  );
  return res.data;
}

// POST - cria um novo link de checkout
export async function createCheckoutLink(data) {
  const res = await axios.post(
    "https://api.sobevenda.com.br/api-proxy/affiliate/checkout-links",
    data,
    { headers: getAuthHeaders() }
  );
  return res.data;
}

// PATCH/PUT - atualiza um link de checkout existente
export async function updateCheckoutLink(id, data) {
  const res = await axios.patch(
    `https://api.sobevenda.com.br/api-proxy/affiliate/checkout-links/${id}`,
    data,
    { headers: getAuthHeaders() }
  );
  return res.data;
}

// DELETE - remove um link de checkout
export async function deleteCheckoutLink(id) {
    const res = await axios.delete(
      `https://api.sobevenda.com.br/api-proxy/affiliate/checkout-links/${id}`,
      { headers: getAuthHeaders() }
    );
    return res.data;
  }

// GET - lista todos os eventos de checkout para um determinado link (por UUID)
export async function getCheckoutEventsByLink(uuid) {
  const res = await axios.get(
    `https://api.sobevenda.com.br/api-proxy/affiliate/checkout-events-by-link?uuid=${uuid}`,
    { headers: getAuthHeaders() }
  );
  return res.data;
}
